import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const VIDEO_PAGE_RECEIVE = 'VIDEO_PAGE_RECEIVE';
export const VIDEO_PAGE_ERROR = 'VIDEO_PAGE_ERROR';
export const VIDEO_CURRENT_UPDATE = 'VIDEO_CURRENT_UPDATE';
export const TAG_LIST_UPDATE = 'TAG_LIST_UPDATE';
export const TAG_ACTIVE_UPDATE = 'TAG_ACTIVE_UPDATE';
export const VIDEO_ACTIVE_UPDATE = 'VIDEO_ACTIVE_UPDATE';

export const fetchVideo = () => (dispatch) => {
    return get('/api/video/')
        .then((response) => {
            return response.json(); // Return the JSON Promise
        })
        .then((result) => {
            dispatch(receive(result)); // Dispatch the receive action
            return result; // Return the result
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => setError(error)));
            throw ex; // Rethrow the error to be caught by the caller
        });
};

export const receive = result => ({
    type: VIDEO_PAGE_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: VIDEO_PAGE_ERROR,
    payload: {
        error,
    },
})

export const updateCurrentVideo = video => ({
    type: VIDEO_CURRENT_UPDATE,
    payload: video
})

export const fetchTags = video => ({
    type: VIDEO_CURRENT_UPDATE,
    payload: video
})

export const updateTagList = tagList => ({
    type: TAG_LIST_UPDATE,
    payload: tagList
})

export const updateActiveTagList = activeTagList => ({
    type: TAG_ACTIVE_UPDATE,
    payload: activeTagList
})

export const updateActiveVideoList = activeVideoList => ({
    type: VIDEO_ACTIVE_UPDATE,
    payload: activeVideoList
})

